import { itemsDataTemplate } from "./itemsDataTemplate";

export function mapProductsFromVariantsAcrossMultipleProducts({
  mixAndMatchProducts,
  getQuantity,
}) {
  return mixAndMatchProducts
    .map((product) =>
      mapItemsFromVariants({
        products: product,
        variants: product.variants,
        getQuantity,
      }),
    )
    .flat();
}

export const mapItemsFromVariants = ({ products, variants, getQuantity }) =>
  variants.map((variant) =>
    itemsDataTemplate({
      products,
      variant,
      getQuantity,
    }),
  );

export const getProductName = ({ products }, variant) =>
  products.find((product) => product.id === variant.productId)?.name;

export const hasSubProducts = (products) => !!products?.products;

export const getTotalValueFromAddedVariants = (productsAdded) =>
  productsAdded.reduce((sum, product) => {
    const price = product.priceLocalCurrency
      ? product.priceLocalCurrency
      : product.priceObj?.current.value;
    return sum + price;
  }, 0);

export const getTotalValueFromAdddedVariantsInGB = (productsAdded) =>
  productsAdded.reduce((sum, product) => {
    const price = product.price?.xrp
      ? product.price.xrp.value
      : product.priceObj?.xrp.value;
    return sum + price;
  }, 0);

export const getVariantStockStatus = (variants) =>
  variants.map((variant) => ({
    variantId: variant.variantId,
    variantSku: variant.sku,
    stockStatus: variant.isInStock ? "in stock" : "out of stock",
  }));

export const getTotalInStock = (variants) =>
  variants.filter((variant) => variant.isInStock === true).length;
